import {
  danger,
  DownloadExcel,
  downloadExcel,
  Modal,
  ModalOpenBtn,
  Table,
  useState,
} from "@";
import { cardShowColumns } from "./TableOptions";
import { excelHeaderCellsNameForShow } from "../utils/options";

const Show = ({ data, loading }) => {
  const [isExporting, setIsExporting] = useState(false);

  // Function to export data to Excel
  async function exportData() {
    try {
      setIsExporting(true);
      await downloadExcel(data, excelHeaderCellsNameForShow);
    } catch (error) {
      danger("خطأ تصدير البيانات");
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <>
      <ModalOpenBtn hidden />
      <Modal size="max-w-4xl" close={() => {}} title="عرض تفاصيل السلة">
        <main className="pb-4">
          <div className="flex justify-end p-2">
            <DownloadExcel
              click={exportData}
              length={data?.length}
              isExporting={isExporting}
            />
          </div>

          {/* Table */}
          <Table
            isSmall
            localPg
            className
            data={data}
            isLoading={loading}
            columns={cardShowColumns}
          />
        </main>
      </Modal>
    </>
  );
};

export default Show;
